import React from 'react';
import './popup-mobile-sticky.scss';

function MobileSticky({popupClass, children, closePopup}) {

    return (
        <div className={popupClass}>
            <header>
                <a href="#!" className="btn-close" onClick={closePopup}>&times;</a>
            </header>
            {children}
        </div>
    );
}

export default MobileSticky;


// WEBPACK FOOTER //
// ./src/fPopup/popup_types/mobile-sticky/index.js